import { Component, OnInit } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '@shared/services/locale.service';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { User } from '@core/models';

@Component({
	selector: 'app-vip',
	templateUrl: './vip.component.html',
	styleUrls: ['./vip.component.scss'],
})
export class VipComponent implements OnInit {
	enVipImage = 'assets/images/vip/en_banner_premiumads.png';
	kuVipImage = 'assets/images/vip/ku_banner_premiumads.png';
	arVipImage = 'assets/images/vip/ar_banner_premiumads.png';

	constructor(private api: ApiService, private route: ActivatedRoute, private title: Title, public locale: LocaleService, private auth: AuthService) {}

	embedded: boolean = false;
	queryAdID: string;
	ad: Object;
	user: User = this.auth.user();
	userId: string;
	login: boolean = false;

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['ads']['ad']['n118'] + ' | ' + this.locale.translations['header']['n0']);

		if (!!this.user) {
			this.userId = this.user['userID'];
			this.login = true;
		}

		this.route.queryParams.subscribe((queries: Params) => {
			this.queryAdID = queries['adID'];
			this.embedded = queries['embedded'];
		});
	}
}
